// extracted by mini-css-extract-plugin
export var img = "logo-module--img--0c163";
export var img__full = "logo-module--img__full--0ab2e";
export var img__small = "logo-module--img__small--56ecc";
export var link = "logo-module--link--94d21";
export var link__full = "logo-module--link__full--812da";
export var logo = "logo-module--logo--1dff4";
export var spin = "logo-module--spin--68893";